<script lang="ts">
    import src from './Icons/svg/play_circle_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';

    export let disabled: boolean = false;
    export let showIcon: boolean = true;
    export let title: string = '';
</script>

<button class="btn-main dont-break" class:showIcon on:click {disabled} {title}>
    <span
        style="filter: brightness(0) saturate(100%) invert(26%) sepia(99%) saturate(1533%) hue-rotate(201deg) brightness(92%) contrast(86%); width:30px; height: 30px;"
    >
        <img {src} alt="Play" class:showIcon />
    </span>
</button>

<style>
    .btn-main {
        background-color: transparent;
        border: none;
        cursor: pointer;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        align-items: center;
        display: flex;
        justify-content: center;
        line-height: 14px;
        padding: 0;
    }
    .btn-main img {
        height: 30px;
        width: 30px;
    }
    .btn-main[disabled] {
        cursor: not-allowed;
    }
    .btn-main[disabled] span {
        filter: none !important;
        opacity: 0.5;
    }
</style>
